// extracted by mini-css-extract-plugin
export default {"main":"_232669274c a7f079e98f","xmark":"_17e2d643cb","fl_img":"bfc54ebc90 b36d28d50e"};